module.exports = __webpack_public_path__ + "media/images/emblems/Lauperswil-coat_of_arms-ca169083ac20873d9bf150a1a89e50b8.svg";